import { __assign, __read, __spreadArray } from "tslib";
import { cloneDeep, get, set } from "lodash";
import { CustomInputType } from "../../components/CustomInput/customInput.model";
import { checkInputValidity, isCustomInputObject } from "../../components/CustomInput/customInput.utils";
import { isObject } from "../isObject";
var customInputValues = Object.values(CustomInputType);
export function createForm(options) {
    var _a = options.defaultValueGetters, defaultValueGetters = _a === void 0 ? {} : _a, _b = options.generateTemplatesFromPaths, generateTemplatesFromPaths = _b === void 0 ? [] : _b, inputs = options.inputs, _c = options.isTopLevel, isTopLevel = _c === void 0 ? true : _c, optStatePath = options.statePath, optTemplateReferencePath = options.templateReferencePath;
    var form = {
        inputs: {},
        pristine: true,
        rawData: {},
        statePath: optStatePath,
        templates: {},
        valid: false
    };
    var formStatePath = options.formStatePath || optStatePath;
    var inputsStatePath = "".concat(optStatePath).concat(isTopLevel ? ".inputs" : "");
    var templateReferencePath = optTemplateReferencePath || "";
    var generateTemplate = generateTemplatesFromPaths.indexOf(templateReferencePath) !== -1;
    var template = {};
    var _loop_1 = function (inputName) {
        var inputConfig = inputs[inputName];
        var innerTemplateReferencePath = "".concat(templateReferencePath.length ? "".concat(templateReferencePath, ".") : "") + "".concat(inputName);
        var innerGenerateTemplatesFromPaths = __spreadArray([], __read(generateTemplatesFromPaths), false);
        if (generateTemplate) {
            innerGenerateTemplatesFromPaths.push(innerTemplateReferencePath);
        }
        if (inputConfig instanceof Array) {
            var innerRawData_1 = [];
            inputConfig.forEach(function (inputConfigItem, index) {
                var _a = createForm(__assign(__assign({}, options), { formStatePath: formStatePath, generateTemplatesFromPaths: innerGenerateTemplatesFromPaths, inputs: inputConfigItem, isTopLevel: false, statePath: "".concat(inputsStatePath, ".").concat(inputName, ".").concat(index), templateReferencePath: innerTemplateReferencePath })), itemRawData = _a.rawData, itemTemplates = _a.templates;
                innerRawData_1.push(itemRawData);
                if (index === 0) {
                    form.templates = __assign(__assign({}, form.templates), itemTemplates);
                    template[inputName] = [itemTemplates[innerTemplateReferencePath]];
                }
            });
            form.inputs[inputName] = [];
            form.rawData[inputName] = innerRawData_1;
            return "continue";
        }
        if (isObject(inputConfig) && !isCreateFormOptionsInputItem(inputConfig)) {
            var _d = createForm(__assign(__assign({}, options), { formStatePath: formStatePath, generateTemplatesFromPaths: innerGenerateTemplatesFromPaths, inputs: inputConfig, isTopLevel: false, statePath: "".concat(inputsStatePath, ".").concat(inputName), templateReferencePath: innerTemplateReferencePath })), itemInputs = _d.inputs, itemRawData = _d.rawData, itemTemplates = _d.templates;
            form.inputs[inputName] = itemInputs;
            form.rawData[inputName] = itemRawData;
            form.templates = __assign(__assign({}, form.templates), itemTemplates);
            template[inputName] = itemTemplates[innerTemplateReferencePath];
            return "continue";
        }
        var actualInputConfig = inputConfig;
        var inputItem = {
            error: null,
            defaultValue: actualInputConfig.defaultValue,
            emptySelectOption: actualInputConfig.emptySelectOption,
            formStatePath: formStatePath,
            hasClearButton: actualInputConfig.hasClearButton,
            imageExtensionName: actualInputConfig.imageExtensionName,
            imageFileType: actualInputConfig.imageFileType,
            imageUrl: actualInputConfig.imageUrl,
            isImageFile: actualInputConfig.isImageFile,
            label: actualInputConfig.label,
            pristine: true,
            placeholder: actualInputConfig.placeholder,
            selectOptions: actualInputConfig.selectOptions,
            statePath: "".concat(inputsStatePath, ".").concat(inputName),
            type: actualInputConfig.type,
            uploaderIconName: actualInputConfig.uploaderIconName,
            uploaderStateLoaderKey: actualInputConfig.uploaderStateLoaderKey,
            useDefaultValueGetterName: actualInputConfig.useDefaultValueGetterName,
            validations: cloneDeep(actualInputConfig.validations)
        };
        var defaultValue = getDefaultValue(inputItem, defaultValueGetters);
        inputItem.defaultValue = defaultValue;
        inputItem.value = defaultValue;
        form.inputs[inputName] = inputItem;
        if (typeof inputItem.value !== "undefined" && inputItem.value !== null) {
            form.rawData[inputName] = inputItem.value;
        }
        if (generateTemplate) {
            var templateItem = cloneDeep(inputItem);
            templateItem.statePath = templateItem.statePath.replace(inputsStatePath, "__PARENT_ITEM_PATH");
            template[inputName] = templateItem;
        }
    };
    for (var inputName in inputs) {
        _loop_1(inputName);
    }
    if (generateTemplate) {
        form.templates[templateReferencePath] = template;
    }
    return form;
}
export function getBaseCreateFormSubItemConfig() {
    return {
        id: { type: CustomInputType.Number },
        draftId: {
            type: CustomInputType.Text,
            useDefaultValueGetterName: "uuidV4"
        },
        deleted: {
            defaultValue: false,
            type: CustomInputType.Checkbox
        }
    };
}
export function getDefaultValue(inputData, defaultValueGetters) {
    var defaultValue = inputData.defaultValue, useDefaultValueGetterName = inputData.useDefaultValueGetterName;
    var actualDefaultValue = defaultValue;
    if (useDefaultValueGetterName) {
        var defaultValueGetter = defaultValueGetters[useDefaultValueGetterName];
        if (typeof defaultValueGetter === "function") {
            actualDefaultValue = defaultValueGetter();
        }
    }
    if (typeof actualDefaultValue === "undefined") {
        if (inputData.type === CustomInputType.Checkbox) {
            actualDefaultValue = false;
        }
        else if (inputData.type === CustomInputType.Chips) {
            actualDefaultValue = [];
        }
        else {
            actualDefaultValue = "";
        }
    }
    return actualDefaultValue;
}
export function getPopulateInputsAction(options) {
    var defaultValueGetters = (options || {}).defaultValueGetters;
    return function populateInputsAction(state, action) {
        var _a = action.payload, inputsStatePath = _a.inputsStatePath, templatesStatePath = _a.templatesStatePath, values = _a.values;
        populateInputs(get(state, inputsStatePath), values, {
            currentPath: inputsStatePath,
            defaultValueGetters: defaultValueGetters,
            setter: function (statePath, value) { return set(state, statePath, value); },
            templates: templatesStatePath ? get(state, templatesStatePath) : {}
        });
    };
}
export function isCreateFormOptionsInputItem(inputConfig) {
    return inputConfig && customInputValues.includes(inputConfig.type);
}
export function parseTemplate(template, parentPath, options) {
    var _a = options || {}, defaultValueGetters = _a.defaultValueGetters, pathSuffix = _a.pathSuffix;
    var templateObject = cloneDeep(template);
    var actualParentPath = "".concat(parentPath).concat(pathSuffix ? ".".concat(pathSuffix) : "");
    var _loop_2 = function (fieldName) {
        var inputData = templateObject[fieldName];
        if (inputData instanceof Array) {
            var newInputData_1 = [];
            var innerParentPath_1 = "".concat(actualParentPath, ".").concat(fieldName);
            inputData.forEach(function (item, index) {
                newInputData_1.push(parseTemplate(item, "".concat(innerParentPath_1, ".").concat(index)));
            });
            templateObject[fieldName] = newInputData_1;
            return "continue";
        }
        if (typeof inputData.statePath !== "string") {
            templateObject[fieldName] = parseTemplate(inputData, "".concat(actualParentPath, ".").concat(fieldName));
            return "continue";
        }
        inputData.statePath = inputData.statePath.replace(/^__PARENT_ITEM_PATH/, actualParentPath);
        inputData.value = getDefaultValue(inputData, defaultValueGetters || {});
    };
    for (var fieldName in templateObject) {
        _loop_2(fieldName);
    }
    return templateObject;
}
export function populateInputs(inputs, values, options) {
    var currentPath = options.currentPath, _a = options.defaultValueGetters, defaultValueGetters = _a === void 0 ? {} : _a, setter = options.setter, _b = options.templates, templates = _b === void 0 ? {} : _b;
    var templateBasePath = options.currentTemplatesPath || currentPath.replace(/\.\d+$/, "");
    var _loop_3 = function (fieldName) {
        var fieldValue = values[fieldName];
        var itemPath = "".concat(currentPath, ".").concat(fieldName);
        var templatePath = "".concat(templateBasePath, ".").concat(fieldName);
        var inputData = inputs[fieldName];
        if (inputData instanceof Array) {
            var actualFieldValue = fieldValue instanceof Array ? fieldValue : [];
            var template_1 = get(templates, [templatePath]);
            if (!template_1) {
                template_1 = get(templates, [templatePath.replace(/(^.+Form(Group)?\.(.+\.)?inputs\.)/, "")]);
            }
            var newInputData_2 = [];
            setter(itemPath, []);
            actualFieldValue.forEach(function (fieldValueItem, fieldValueItemIndex) {
                newInputData_2 = __spreadArray(__spreadArray([], __read(newInputData_2), false), [
                    parseTemplate(template_1, itemPath, {
                        defaultValueGetters: defaultValueGetters,
                        pathSuffix: "".concat(fieldValueItemIndex)
                    })
                ], false);
                setter(itemPath, newInputData_2);
                populateInputs(newInputData_2[fieldValueItemIndex], fieldValueItem, __assign(__assign({}, options), { currentPath: "".concat(itemPath, ".").concat(fieldValueItemIndex), currentTemplatesPath: templatePath }));
            });
            return "continue";
        }
        else if (isObject(inputData) && !isCustomInputObject(inputData)) {
            var template = get(templates, [templatePath]);
            if (!template) {
                template = get(templates, [templatePath.replace(/(^.+Form\.inputs\.)/, "")]);
            }
            if (template) {
                template = parseTemplate(template, itemPath, { defaultValueGetters: defaultValueGetters });
                setter(itemPath, template);
            }
            populateInputs(template || inputData, (fieldValue || {}), __assign(__assign({}, options), { currentPath: itemPath, currentTemplatesPath: templatePath }));
            return "continue";
        }
        var valueToSet = fieldValue;
        if (typeof fieldValue === "undefined") {
            valueToSet = getDefaultValue(inputData, defaultValueGetters);
        }
        setter("".concat(inputData.statePath, ".value"), valueToSet);
    };
    for (var fieldName in inputs) {
        _loop_3(fieldName);
    }
}
export function validateFormAction(state, action) {
    var _a = action.payload, formStatePath = _a.formStatePath, markInputsAsDirty = _a.markInputsAsDirty;
    var form = get(state, formStatePath);
    var _b = validateInputs(form.inputs, {
        markInputsAsDirty: markInputsAsDirty,
        recheckInputs: true,
        setter: function (statePath, value) { return set(state, statePath, value); }
    }), pristine = _b.pristine, rawData = _b.rawData, valid = _b.valid;
    set(state, "".concat(formStatePath, ".rawData"), rawData);
    set(state, "".concat(formStatePath, ".valid"), valid);
    if (typeof pristine !== "undefined") {
        set(state, "".concat(formStatePath, ".pristine"), pristine);
    }
}
export function updateFormInputsPath(input, path) {
    if (input instanceof Array) {
        input.forEach(function (inputDataItem, index) {
            updateFormInputsPath(inputDataItem, "".concat(path, ".").concat(index));
        });
    }
    else if (isObject(input) && !isCustomInputObject(input)) {
        for (var key in input) {
            updateFormInputsPath(input[key], "".concat(path, ".").concat(key));
        }
    }
    else {
        input.statePath = "".concat(path);
    }
}
export function validateInputs(inputs, options) {
    var rawData = {};
    var opt = options || {};
    var markInputsAsDirty = opt.markInputsAsDirty, _a = opt.recheckInputs, recheckInputs = _a === void 0 ? true : _a, setter = opt.setter;
    var deleted = inputs.deleted;
    var valid = true;
    var _loop_4 = function (fieldName) {
        var inputData = inputs[fieldName];
        if (inputData instanceof Array) {
            var inputRawData_1 = [];
            inputData.forEach(function (inputDataItem) {
                var _a;
                if ((_a = inputDataItem.deleted) === null || _a === void 0 ? void 0 : _a.value)
                    return;
                var inputValidationData = validateInputs(inputDataItem, opt);
                if (!inputValidationData.valid && valid) {
                    valid = false;
                }
                inputRawData_1.push(inputValidationData.rawData);
            });
            rawData[fieldName] = inputRawData_1;
            return "continue";
        }
        if (isObject(inputData) && !isCustomInputObject(inputData)) {
            var inputValidationData = validateInputs(inputData, opt);
            if (!inputValidationData.valid && valid) {
                valid = false;
            }
            rawData[fieldName] = inputValidationData.rawData;
            return "continue";
        }
        inputData = inputData;
        if (recheckInputs) {
            var statePath = inputData.statePath;
            inputData = checkInputValidity(inputData, {
                markAsDirty: markInputsAsDirty
            });
            if (setter) {
                for (var fieldName_1 in inputData) {
                    setter("".concat(statePath, ".").concat(fieldName_1), inputData[fieldName_1]);
                }
            }
        }
        if (inputData.value !== null && (inputData.type !== CustomInputType.Text || inputData.value !== "")) {
            rawData[fieldName] = inputData.value;
        }
        if (inputData.error) {
            if (valid && (!deleted || !deleted["value"])) {
                valid = false;
            }
        }
    };
    for (var fieldName in inputs) {
        _loop_4(fieldName);
    }
    var returnData = {
        rawData: rawData,
        valid: valid
    };
    if (markInputsAsDirty) {
        returnData.pristine = false;
    }
    return returnData;
}
//# sourceMappingURL=form.utils.js.map